<template>
	<div id="personalCenter">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					{{schoolInfo.logo}}
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->
		</div>



		<div class="companyInfoIpt">
			<div class="titleContainer">
				<!-- <div class="shu">
				</div> -->
				<div class="title" v-if="nextToken">
					个人中心
				</div>
				<div class="title" v-else style="cursor: pointer;color: #1E40AF;" @click="toLogin">
					点击登录/注册
				</div>
			</div>


			<div class="statistics">
				<div class="item" style="margin-right: 8px;background: linear-gradient(90deg, #B6FFFF, #E9FFFF);cursor: pointer;" @click="toAlreadyCommunicated">
					<div class="num" :style="nextToken?'':'color:#666666;'">
						{{nextToken?has_chat_cnt:'**'}}
					</div>
					<div class="text">
						沟通过
					</div>
				</div>
				<div class="item" style="background: linear-gradient(90deg, #FFEADD, #FFF8F4);cursor: pointer;" @click="toReceivedResume">
					<div class="num" :style="nextToken?'':'color:#666666;'">
						{{nextToken?post_user_cnt:'**'}}
					</div>
					<div class="text">
						收到简历
					</div>
				</div>
			</div>


			<div class="other">
				<div class="left">
					<img src="../img/index1.png" alt="" />
					<div class="">
						企业详情
					</div>
				</div>
				<el-button type="primary" @click="navto('corporateImage')">点击查看</el-button>
				<!-- <div class="right" @click="navto('corporateImage')">
					点击查看
				</div> -->
			</div>


			<div class="other">
				<div class="left">
					<img src="../img/index2.png" alt="" />
					<div class="">
						评论管理
					</div>
				</div>
				<!-- <div class="right" @click="navto('commentManagement')">
					点击查看
				</div> -->
				<el-button type="primary" @click="navto('commentManagement')">点击查看</el-button>
			</div>



			<div class="other">
				<div class="left">
					<img src="../img/index3.png" alt="" />
					<div class="">
						职位管理
					</div>
				</div>
				<!-- <div class="right" @click="navto('positionManagement')">
					点击查看
				</div> -->
				<el-button type="primary" @click="navto('positionManagement')">点击查看</el-button>
			</div>


			<div class="other">
				<div class="left">
					<img src="../img/index4.png" alt="" />
					<div class="">
						消息推送
					</div>
				</div>
				<!-- <div class="right" @click="navto('pushMessage')">
					点击查看
				</div> -->
				<el-button type="primary" @click="navto('pushMessage')">点击查看</el-button>
			</div>

			<!-- <div class="other">
				<div class="left">
					<img src="../img/index5.png" alt="" />
					<div class="">
						社区广告
					</div>
				</div>
				<el-button type="primary" @click="navto('communityPromotion')">点击查看</el-button>
			</div> -->


			<!-- <div class="other">
				<div class="left">
					<img src="../img/index6.png" alt="" />
					<div class="">
						生源使用查询
					</div>
				</div>
				
				<el-button type="primary" @click="navto('communityPromotion')">点击查看</el-button>
			</div> -->
			<div class="other" >
				<div class="left">
					<img src="../img/cooperation.png" alt="" />
					<div class="">
						校企合作需求发布
					</div>
				</div>
				<!-- <div class="right" @click="navto('accountManagement')">
					点击查看
				</div> -->
				<el-button type="primary" @click="toCooperation">点击查看</el-button>
			</div>
			<div class="other" v-if="nextToken">
				<div class="left">
					<img src="../img/index10.png" alt="" />
					<div class="">
						开票管理
					</div>
				</div>
				<!-- <div class="right" @click="navto('accountManagement')">
					点击查看
				</div> -->
				<el-button type="primary" @click="examine">点击查看</el-button>
			</div>
			<!-- <div class="other" v-if="nextToken">
				<div class="left">
					<img src="https://oss.sx985.com/2026/09/02/xxxrecharege.png" alt="" />
					<div class="">
						简历充值管理
					</div>
				</div>
				<el-button type="primary" @click="navto('resumeRecharge')">点击查看</el-button>
			</div> -->

			<div class="other" v-if="showPermission&&nextToken">
				<div class="left">
					<img src="../img/index7.png" alt="" />
					<div class="">
						账户管理
					</div>
				</div>
				<!-- <div class="right" @click="navto('accountManagement')">
					点击查看
				</div> -->
				<el-button type="primary" @click="navto('accountManagement')">点击查看</el-button>
			</div>
			
			<div class="other" v-if="nextToken">
				<div class="left">
					<img src="../img/index11.png" alt="" />
					<div class="">
						切换账号
					</div>
				</div>
				<!-- <div class="right" @click="navto('accountManagement')">
					点击查看switchAccount
				</div> -->
				<el-button type="primary" @click="navto('switchAccount')">点击查看</el-button>
			</div>
			
			<div class="other" v-if="nextToken">
				<div class="left">
					<img src="../img/index8.png" alt="" />
					<div class="">
						账户注销
					</div>
				</div>
				<!-- <div class="right" @click="writeOff">
					账户注销
				</div> -->
				<el-button type="primary" @click="writeOff">点击注销</el-button>
			</div>
		</div>
		
		
		<!-- <div class="elDialogBox">
		
			<el-dialog title="切换账号" :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
				<div class="elDialog">
					
					
					
				</div>
			</el-dialog>
		</div> -->
			
			<div class="preview">
				<el-dialog :visible.sync="dialogVisible" :show-close="false" width="450px">
					<div class="elDialog">
						<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
						<div class="main">
							<div class="title">开票管理</div>
							<div class="qrcodeContainer">
								<div class="qrcode">
									<div class="qrcodeImage" v-if="qrcodeImg">
										<img class="qrcodeImg" :src="qrcodeImg" alt="" />
										<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
									</div>
									<div class="hite1">扫描<span style="color: #0084ff">识别二维码打开小程序管理发票</span></div>
									<!-- <div class="hite2">可在手机上查看</div> -->
								</div>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>

	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	const config = require('../../WebConfig')
	export default {
		data() {
			return {
				has_chat_cnt: 0,
				post_user_cnt: 0,
				showPermission: false,
				dialogVisible:false,
				qrcodeImg: '',
			};
		},
		mounted() {
			if(this.nextToken){
				this.myCompanyCenter()
			}
			// this.getComUserInfoListByPhone()
			if (this.userInfo.is_main) {
				this.showPermission = true
			}
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			if(!this.qrcodeImg){
				this.getQrcode()
			}
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		methods: {
			...mapMutations(['setIslogin', 'setAdminId', 'setUserInfo', 'setSchoolData', 'setUserId','setToken']),
			toCooperation(){
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: '/cooperation',
				})
			},
			// switchAccount(){
			// 	this.dialogVisible = true
			// },
			// handleClose(){
			// 	this.dialogVisible = false
			// },
			getQrcode() {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/service/invoicelist&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			examine(){
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: '/invoiceList'
				})
			},
			closeElDialog(){
				this.dialogVisible = false
			},
			toLogin(){
				this.$router.push({
					path: `/login`,
					// query: {
					//   isAlreadyCommunicated: 2,
					// },
				});
			},
			toReceivedResume(){
				if(this.post_user_cnt!=0){
					this.$router.push({
						path: `/messageManagement`,
						query: {
						  isAlreadyCommunicated: 2,
						},
					});
				}
			},
			
			toAlreadyCommunicated(){
				if(this.has_chat_cnt!=0){
					this.$router.push({
						path: `/messageManagement`,
						query: {
						  
						},
					});
				}
				
			},
			navto(path) {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: `/${path}`,
					// query: {
					//   id: 1,
					// },
				});
			},
			
			// getComUserInfoListByPhone() {
			// 	this.$util.post(
			// 		"v2/school_job/getComUserInfoListByPhone", {
			// 			tel: 15927596309,
			// 		},
			// 		(res) => {
						
			// 			if (res.code == 0) {
			// 				console.log(res)
							
			// 			} else {
			// 				this.$message.error(res.msg);
			// 			}
			// 		}
			// 	);
			// },
			
			myCompanyCenter() {
				this.$util.post(
					"v2/school_job/myCompanyCenter", {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {
						
						if (res.code == 0) {
							
							this.has_chat_cnt = res.data.has_chat_cnt
							this.post_user_cnt = res.data.post_user_cnt
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			writeOff() {
				this.$confirm('您确定注销账号吗，注销后数据无法恢复，请谨慎操作!', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$util.post(
						"job/im/updateUserStatus", {
							userId:localStorage.getItem('admin_id'),
							platform:3,
							userType:1,
							onlineStatus:1,
						},
						(res) => {
						}
					);
					
					this.$util.post(
						"v2/school_job/unbind_subacc", {
							id: this.userInfo.id,
						},
						(res) => {
							
							if (res.code == 0) {
								localStorage.removeItem('user_id')
								localStorage.removeItem('userInfo')
								localStorage.removeItem('schoolData')
								localStorage.removeItem('admin_id')
								localStorage.removeItem('nextToken')
								sessionStorage.removeItem('applyData')
								//缺少清空vuex储存的数据
								this.setAdminId('')
								this.setUserInfo('')
								this.setSchoolData('')
								this.setUserId('')
								this.setToken('')
								this.$message({
									type: 'success',
									message: '注销成功!',
									duration: 1500,
								});

								setTimeout(() => {
									this.$router.push({
										path: `/login`,
										// query: {
										//   id: 1,
										// },
									});
								}, 1500)
							} else {
								this.$message.error(res.msg);
							}
						}
					);

				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消注销'
					// });
				});
			}
		},
		components: {},
	};
</script>
<style type="text/css">
	#personalCenter .preview .el-dialog {
		background: initial;
		box-shadow: initial;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				// margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 40px 0 40px;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.statistics {
				width: 833px;
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				.item {
					flex: 1;
					background: #F6F7FB;
					border-radius: 10px;
					display: flex;
					align-items: center;
					flex-direction: column;
					padding: 25px 0;
					// cursor: pointer;

					.num {
						// font-weight: bold;
						font-size: 24px;
						color: #333;
						margin-bottom: 20px;
					}

					.text {
						font-weight: 400;
						font-size: 16px;
						color: #333333;
					}
				}
			}

			.other {
				width: 833px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 10px;
				box-sizing: border-box;
				padding: 20px;
				background: #F6F7FB;
				border-radius: 10px;

				.left {
					display: flex;
					align-items: center;

					font-size: 0;

					img {
						width: 35px;
						margin-right: 30px;
					}

					div {
						font-weight: 500;
						font-size: 16px;
						color: #000000;
					}
				}

				.right {
					width: 88px;
					height: 35px;
					background: #4F8FF0;
					border-radius: 5px;

					text-align: center;
					line-height: 35px;
					font-weight: 500;
					font-size: 14px;
					color: #FFFFFF;
					cursor: pointer;
				}
			}


		}
	}
	
	
	
	#personalCenter .elDialogBox .el-dialog__header {
		padding: 20px 30px 10px 30px !important;
	}
	
	
	
	
	
	
	
	.elDialog {
		position: relative;
		font-size: 0;
	
		.main {
			box-sizing: border-box;
			padding: 30px 20px 50px 20px;
			background: #ffffff;
			border-radius: 10px;
	
			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}
	
		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}
	
	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	
		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #ffffff;
			border-radius: 10px;
			border: 4px solid #0084ff;
	
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;
	
			.qrcodeImage {
				position: relative;
				width: 208px;
				height: 245px;
			}

			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.qrcodeLogo {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				width: 90px;
				height: 90px;
				border-radius: 50%;
				margin: 58px auto;
			}
	
			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}
	
			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
				
			}
		}
	}
</style>
